/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { MappingMatrixPageEntrypointProps } from './MappingMatrixPage.entrypoint.types.tsx';

type MappingMatrixEntryPointComponent = EntryPointComponent<
	{},
	{},
	MappingMatrixPageEntrypointProps,
	{}
>;

export const mappingMatrixEntryPoint: EntryPoint<MappingMatrixEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<MappingMatrixEntryPointComponent>(
			/* webpackChunkName: "async-mapping-matrix-page" */ './MappingMatrixPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
